import { createStore } from 'vuex';
// import axios from 'axios';

export default createStore({
  state: {
    // recipes: {},
  },
  getters: {
  },
  mutations: {
    // SET_RECIPES: (state, recipes) => {
    //   state.recipes = recipes;
    // },

  },
  actions: {
    // async getAllRecipes({ commit }) {
    //   const response = await axios.get('https://forkify-api.herokuapp.com/api/v2/recipes');
    //   const { data } = response.data;

    //   commit('SET_RECIPES', data);
    // },
  },
  modules: {
  },
});
